
import { Shield, Clock, Award, Users } from "lucide-react";

const TrustBadges = () => {
  return (
    <section className="section-gap-top" style={{ backgroundColor: 'rgba(27, 33, 57, 0.95)' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#F4F4F4] mb-6">
            Why Choose Our Cam‑Picking Team?
          </h2>
          <p className="text-[#F4F4F4] text-sm md:text-base max-w-2xl mx-auto">
            Trusted by buyers picking vintage via live video
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
          <div className="text-center p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#364264]" style={{ backgroundColor: '#364264' }}>
            <div className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" style={{ backgroundColor: '#D9992B' }}>
              <Clock className="w-6 h-6 md:w-8 md:h-8 text-[#F4F4F4]" />
            </div>
            <h3 className="font-bold text-[#F3B340] mb-1 md:mb-2 text-sm md:text-base">Quick Booking</h3>
            <p className="text-[#F4F4F4] text-xs md:text-sm">Pick a time online for live cam picking</p>
          </div>
          
          <div className="text-center p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#364264]" style={{ backgroundColor: '#364264' }}>
            <div className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" style={{ backgroundColor: '#D9992B' }}>
              <Shield className="w-6 h-6 md:w-8 md:h-8 text-[#F4F4F4]" />
            </div>
            <h3 className="font-bold text-[#F3B340] mb-1 md:mb-2 text-sm md:text-base">Clear Pricing</h3>
            <p className="text-[#F4F4F4] text-xs md:text-sm">Categories and rates listed for easy choices</p>
          </div>
          
          <div className="text-center p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#364264]" style={{ backgroundColor: '#364264' }}>
            <div className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" style={{ backgroundColor: '#D9992B' }}>
              <Award className="w-6 h-6 md:w-8 md:h-8 text-[#F4F4F4]" />
            </div>
            <h3 className="font-bold text-[#F3B340] mb-1 md:mb-2 text-sm md:text-base">Cam‑Picking Pros</h3>
            <p className="text-[#F4F4F4] text-xs md:text-sm">Guiding you through rails & boxes in real time</p>
          </div>
          
          <div className="text-center p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#364264]" style={{ backgroundColor: '#364264' }}>
            <div className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" style={{ backgroundColor: '#D9992B' }}>
              <Users className="w-6 h-6 md:w-8 md:h-8 text-[#F4F4F4]" />
            </div>
            <h3 className="font-bold text-[#F3B340] mb-1 md:mb-2 text-sm md:text-base">Minimums That Fit</h3>
            <p className="text-[#F4F4F4] text-xs md:text-sm">500€ net from 4+ categories; fast dispatch</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
